export default {
      id: "ic_telecharger-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_telecharger-usage",
      toString: function () {
        return this.url;
      }
    }